import React, {useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";

import {  DatePicker, FormDialog, MaskedTime }from "../../../../controls";
import Validator from "../../validators/TripTimesValidator";
import { Icon, IconButton, Tooltip } from '@material-ui/core';

const AccessControl = require ("../../../../AccessControl");

const TripTimesDialog = (props) => {
  const now = moment.utc();
  const minDate = moment.utc().subtract(1, 'month');
  const maxDate = moment(minDate).add(3, 'year');
  const initialDate = now.toISOString();
  const dateFormat = "DD/MM/YYYY";
  const { user } = useAuth0();

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {etd: initialDate},
    handleSave: null,
    canChangeEstimated: AccessControl.userHasAccess(user, ["Edit Flight Estimated Dates"]) || AccessControl.userHasAccess(user, ["Super Admin"])
  });

  const open = (tripLeg, handleSave) => {
    const record = {
      ctd: tripLeg.contractedDepartureTimeUTC,
      cta: tripLeg.contractedArrivalTimeUTC,
      std: tripLeg.scheduledDepartureTimeUTC,
      sta: tripLeg.scheduledArrivalTimeUTC,
      etd: tripLeg.estimatedDepartureTimeUTC||tripLeg.scheduledDepartureTimeUTC,
      eta: tripLeg.estimatedArrivalTimeUTC||tripLeg.scheduledArrivalTimeUTC
    };
    setDialogStates({...dialogStates, showDialog:true, record, handleSave});
  }
  const close = () => {
    setDialogStates({...dialogStates, showDialog:false, record: {}, handleSave: null});
  }

  const Dialog = (props) => {
    const classes = props.classes;
    if (dialogStates.showDialog) {
      return (
        <FormDialog
          title={"Flight Times"}
          message="Specify the flight times for departure and arrival"
          open={dialogStates.showDialog}
          record={dialogStates.record}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              const scheduledDepartureTimeUTC = record.std;
              const scheduledArrivalTimeUTC = record.sta;
              let estimatedDepartureTimeUTC = record.etd;
              let estimatedArrivalTimeUTC = record.eta;
              if (estimatedDepartureTimeUTC == scheduledDepartureTimeUTC) estimatedDepartureTimeUTC = null;
              if (estimatedArrivalTimeUTC == scheduledArrivalTimeUTC) estimatedArrivalTimeUTC = null;
              if (dialogStates.handleSave) dialogStates.handleSave({scheduledDepartureTimeUTC, scheduledArrivalTimeUTC, estimatedDepartureTimeUTC, estimatedArrivalTimeUTC});
              setDialogStates({...dialogStates, showDialog: false, record: null, handleSave: null});
            } else {
              setDialogStates({...dialogStates, showDialog: false, record: null, handleSave: null});
            }
          }}
        >
          <div style={{padding: 2, position: "relative", fontWeight: 1000}}>Planned</div>
          <div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}}>STD:</div>
            <div style={{display: "inline-block", padding: 2, position: "relative", top: 5}} checkChildren={true}>
              <DatePicker
                id="std"
                style={{width: "100%"}}
                minDate={minDate}
                maxDate={maxDate}
                defaultValue={initialDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                onChange={(value, props) => {
                  const {record, recordChange} = props;
                  const newTripDate = moment(value).startOf('day');
                  if (!newTripDate.isValid()) return;
                  const diffDays = newTripDate.diff(moment(record.std).startOf('day'), 'days');
                  const std = moment(record.std).add(diffDays, 'days').toISOString();
                  recordChange({
                    std,
                    etd: std
                  });
                }}
              />
            </div>

            <div style={{display: "inline-block", padding: 2, position: "relative", top: -2}} checkChildren={true}>
              {(record, changeRecord) => (
                <MaskedTime
                  id="std"
                  source="timestamp"
                  onChange={(value)=>{
                    if (!value) return;
                    if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length !== 2) return;
                    value = value.replace(/\s/g, '0');
                    const [hours,  minutes] =  value.split(':');
                    if (isNaN(hours) || hours < 0 || hours > 23) return;
                    if (isNaN(minutes) || minutes < 0 || hours > 59) return;
                    let std = record.std;
                    const newStd = moment.utc(std).startOf('day')
                                                              .add(hours, 'hour')
                                                              .add(minutes, 'minute')
                                                              .toISOString();
                    changeRecord({
                      std: newStd,
                      etd: newStd
                    });
                  }}
                />
              )}
            </div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}} checkChildren={true}>
            {(record, changeRecord) => (
              <Tooltip title="Revert to CTD">
                <IconButton style={{padding:2}} onClick={()=> {
                  changeRecord({
                    std: record.ctd
                  })
                }}><Icon>restore</Icon></IconButton>
              </Tooltip>
            )}
            </div>
          </div>
          <div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}}>STA:</div>
            <div style={{display: "inline-block", padding: 2, position: "relative", top: 5}} checkChildren={true}>
              <DatePicker
                id="sta"
                style={{width: "100%"}}
                minDate={minDate}
                maxDate={maxDate}
                defaultValue={initialDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                onChange={(value, props) => {
                  const {record, recordChange} = props;
                  const newTripDate = moment(value).startOf('day');
                  if (!newTripDate.isValid()) return;
                  const diffDays = newTripDate.diff(moment(record.sta).startOf('day'), 'days');
                  const sta = moment(record.sta).add(diffDays, 'days').toISOString();
                  recordChange({
                    sta,
                    eta: sta
                  });
                }}
              />
            </div>

            <div style={{display: "inline-block", padding: 2, position: "relative", top: -2}} checkChildren={true}>
              {(record, changeRecord) => (
                <MaskedTime
                  id="sta"
                  source="timestamp"
                  onChange={(value)=>{
                    if (!value) return;
                    if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length !== 2) return;
                    value = value.replace(/\s/g, '0');
                    const [hours,  minutes] =  value.split(':');
                    if (isNaN(hours) || hours < 0 || hours > 23) return;
                    if (isNaN(minutes) || minutes < 0 || hours > 59) return;
                    let sta = record.sta;
                    const newSta = moment.utc(sta).startOf('day')
                                                              .add(hours, 'hour')
                                                              .add(minutes, 'minute')
                                                              .toISOString();
                    changeRecord({
                      sta: newSta,
                      eta: newSta
                    });
                  }}
                />
              )}
            </div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}} checkChildren={true}>
            {(record, changeRecord) => (
              <Tooltip title="Revert to CTA">
                <IconButton style={{padding:2}} onClick={()=> {
                  changeRecord({
                    sta: record.cta
                  })
                }}><Icon>restore</Icon></IconButton>
              </Tooltip>
            )}
            </div>
          </div>
          <div style={{padding: 2, paddingTop:10, position: "relative", fontWeight: 1000}}>Estimated</div>
          <div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}}>ETD:</div>
            <div style={{display: "inline-block", padding: 2, position: "relative", top: 5}} checkChildren={true}>
              <DatePicker
                id="etd"
                style={{width: "100%"}}
                minDate={minDate}
                maxDate={maxDate}
                defaultValue={initialDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                readOnly={!dialogStates.canChangeEstimated}
                onChange={(value, props) => {
                  const {record, recordChange} = props;
                  const newTripDate = moment(value).startOf('day');
                  if (!newTripDate.isValid()) return;
                  const diffDays = newTripDate.diff(moment(record.etd).startOf('day'), 'days');
                  const etd = moment(record.etd).add(diffDays, 'days').toISOString();
                  recordChange({etd});
                }}
              />
            </div>

            <div style={{display: "inline-block", padding: 2, position: "relative", top: -2}} checkChildren={true}>
              {(record, changeRecord) => (
                <MaskedTime
                  id="etd"
                  source="timestamp"
                  readOnly={!dialogStates.canChangeEstimated}
                  onChange={(value)=>{
                    if (!value) return;
                    if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length !== 2) return;
                    value = value.replace(/\s/g, '0');
                    const [hours,  minutes] =  value.split(':');
                    if (isNaN(hours) || hours < 0 || hours > 23) return;
                    if (isNaN(minutes) || minutes < 0 || hours > 59) return;
                    let etd = record.etd;
                    const newEtd = moment.utc(etd).startOf('day')
                                                              .add(hours, 'hour')
                                                              .add(minutes, 'minute')
                                                              .toISOString();
                    changeRecord({
                      etd: newEtd
                    });
                  }}
                />
              )}
            </div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}} checkChildren={true}>
            {(record, changeRecord) => (
              <Tooltip title="Revert to STD">
                <IconButton
                  style={{padding:2}}
                  disabled={!dialogStates.canChangeEstimated}
                  onClick={()=> {
                    changeRecord({
                      etd: record.std
                    })
                  }
                }><Icon>restore</Icon></IconButton>
              </Tooltip>
            )}
            </div>
          </div>
          <div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}}>ETA:</div>
            <div style={{display: "inline-block", padding: 2, position: "relative", top: 5}} checkChildren={true}>
              <DatePicker
                id="eta"
                style={{width: "100%"}}
                minDate={minDate}
                maxDate={maxDate}
                defaultValue={initialDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
                readOnly={!dialogStates.canChangeEstimated}
                onChange={(value, props) => {
                  const {record, recordChange} = props;
                  const newTripDate = moment(value).startOf('day');
                  if (!newTripDate.isValid()) return;
                  const diffDays = newTripDate.diff(moment(record.eta).startOf('day'), 'days');
                  const eta = moment(record.eta).add(diffDays, 'days').toISOString();
                  recordChange({eta});
                }}
              />
            </div>

            <div style={{display: "inline-block", padding: 2, position: "relative", top: -2}} checkChildren={true}>
              {(record, changeRecord) => (
                <MaskedTime
                  id="eta"
                  source="timestamp"
                  readOnly={!dialogStates.canChangeEstimated}
                  onChange={(value)=>{
                    if (!value) return;
                    if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length !== 2) return;
                    value = value.replace(/\s/g, '0');
                    const [hours,  minutes] =  value.split(':');
                    if (isNaN(hours) || hours < 0 || hours > 23) return;
                    if (isNaN(minutes) || minutes < 0 || hours > 59) return;
                    let eta = record.eta;
                    const newEta = moment.utc(eta).startOf('day')
                                                              .add(hours, 'hour')
                                                              .add(minutes, 'minute')
                                                              .toISOString();
                    changeRecord({
                      eta: newEta
                    });
                  }}
                />
              )}
            </div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}} checkChildren={true}>
            {(record, changeRecord) => (
              <Tooltip title="Revert to STA">
                <IconButton
                  style={{padding:2}}
                  disabled={!dialogStates.canChangeEstimated}
                  onClick={()=> {
                    changeRecord({
                      eta: record.sta
                    })
                  }
                }><Icon>restore</Icon></IconButton>
              </Tooltip>
            )}
            </div>
          </div>
        </FormDialog>
      )
    }
    return (<></>);
  }
  return {
    Dialog,
    open,
    close
  }

}

export default TripTimesDialog;
